export default __webpack_public_path__ + "static/media/achieving-a-goal.e6d9de52.svg";